import { api } from "@/api/api";
import { useAccount } from "wagmi";
import { message } from "antd";
import React, { use, useEffect, useState } from "react";
import styled from "styled-components";
import useTwitterBindAutoClear from "@/hooks/walletHooks";
import { API_BASE_URL } from "@/pkg/util/constants";

const SocialButton = () => {
  const { address } = useAccount();
  const [isBound, setIsBound] = useState(false);
  const [avatar, setAvatar] = useState<string | null>(null);
  const [username, setUsername] = useState<string | null>(
    localStorage.getItem("twitterUsername")
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const checkBind = async () => {
      if (address) {
        try {
          const res = await api.get(
            `/cryptokill/twitter/has-bind?wallet=${address}`
          );
          const data = res.data;

          if (data.bound) {
            setIsBound(true);
            if (data.avatar) {
              setAvatar(data.avatar);
              localStorage.setItem("twitterAvatar", data.avatar);
            }
            if (
              data.username &&
              localStorage.getItem("twitterUsername") !== data.username
            ) {
              localStorage.setItem("twitterUsername", data.username);
              setUsername(data.username); 
              message.success(`已绑定 @${data.username}`);
            }
            localStorage.setItem("twitterBound", "true");
          } else {
            clearTwitterCache();
          }
        } catch (e) {
          clearTwitterCache();
        }
      } else {
        clearTwitterCache();
      }
    };

    const clearTwitterCache = () => {
      setIsBound(false);
      setAvatar(null);
      localStorage.setItem("twitterBound", "false");
      localStorage.removeItem("twitterAvatar");
      localStorage.removeItem("twitterUsername");
    };

    checkBind();
  }, [address]);

  const handleClick = () => {
    if (!address) {
      message.error("请先连接钱包");
      return;
    }
    if (isBound) {
      message.info("已绑定 X 账号");
      return;
    }
    setLoading(true);
    const currentURL = encodeURIComponent(window.location.href);
    window.location.href = `${API_BASE_URL}/cryptokill/twitter/initiate?address=${address}&state=${currentURL}`;
  };

  useTwitterBindAutoClear();
  return (
    <StyledWrapper>
      {isBound && avatar && (
        <div className="social-user-info">
          <img src={avatar} alt="X Avatar" className="x-avatar" />
          <div className="username-display">@{username}</div>
        </div>
      )}
      {!isBound && <button
        onClick={handleClick}
        disabled={isBound}
        style={isBound ? { cursor: "default", opacity: 0.7 } : {}}
      >
        {!isBound && (
          <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            height={28}
            width={28}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17.53 2H21.5L14.36 10.39L22.74 22H16.42L11.41 15.3L5.77 22H1.79L9.34 13.08L1.25 2H7.73L12.29 8.13L17.53 2ZM16.37 20.13H18.19L7.7 3.76H5.74L16.37 20.13Z" />
          </svg>
        )}
      </button>}
      
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  button {
    background: transparent;
    position: relative;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    text-decoration: none;
    cursor: pointer;
    border: 1.5px solid rgb(252, 252, 252);
    border-radius: 25px;
    outline: none;
    overflow: hidden;
    color: rgb(252, 252, 252);
    transition: color 0.3s 0.1s, border 0.3s, background 0.3s;
    text-align: center;
    box-shadow: 0 2px 12px rgb(252, 252, 252) 22;
    min-width: 38px;
    min-height: 38px;
    justify-content: center;
  }

  .social-user-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .x-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    border: 1.5px solid #fff;
    background: #fff;
  }

  .username-display {
    color: #fff;
    font-size: 14px;
    font-family: "Orbitron", "Arial", sans-serif;
  }

  button:disabled {
    background: rgba(255, 255, 255, 0.08);
    cursor: default;
    color: #ccc;
    border: 1.5px solid #ccc;
  }

  button:hover:enabled {
    color: #fff;
    border: 1.5px solid rgb(153, 49, 222);
    background: linear-gradient(
      90deg,
      rgb(153, 49, 222) 0%,
      rgb(153, 49, 222) 100%
    );
    box-shadow: 0 0 24px rgb(153, 49, 222) 55;
  }

  button:hover:enabled::before {
    box-shadow: inset 0 0 0 10em rgb(153, 49, 222);
  }
`;

export default SocialButton;
